export default "__VITE_ASSET__B4YUnEqO__"